export const ngo_list = `/v2/guest/filter-ngos`;
